<script lang="ts">
	export let title: string;
	export let description: string;

</script>

<div class="achievement-body" data-testid="achievement-body" aria-label="Challenge: {title}, {description}.">
	<slot />
	<div aria-hidden="true" class="oc-headline-50">{title}</div>
	<div aria-hidden="true" class="oc-copy-75">{description}</div>
</div>